import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_check_circle.svg'


const _hoisted_1 = {
  id: "booking-v4-reference-section",
  "data-testid": "booking-v4-reference-section",
  class: "grid grid-cols-2 gap-4"
}
const _hoisted_2 = { class: "col-span-1" }
const _hoisted_3 = { class: "flex items-center gap-1 mb-2" }
const _hoisted_4 = { class: "text-xs font-medium text-black-lp-300" }
const _hoisted_5 = {
  key: 0,
  class: "text-xs font-medium text-gray-lp-500"
}
const _hoisted_6 = { class: "flex items-center gap-1.5" }
const _hoisted_7 = { class: "break-all" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs text-red-lp-1200 mt-1"
}
const _hoisted_9 = {
  key: 1,
  class: "text-xs text-red-lp-1200 mt-1"
}
const _hoisted_10 = {
  key: 2,
  class: "text-xs text-red-lp-1200 mt-1"
}
const _hoisted_11 = {
  key: 3,
  class: "mt-1 flex items-center gap-1"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "w-5 h-5",
  src: _imports_0,
  alt: "check"
}, null, -1)
const _hoisted_13 = { class: "text-xs text-green-lp-400" }
const _hoisted_14 = { class: "col-span-1 flex items-center pt-5" }
const _hoisted_15 = { class: "text-xs text-gray-lp-800 mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chips = _resolveComponent("Chips")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("bookingV4.referenceNumber.title")), 1),
        (!_ctx.isRequired)
          ? (_openBlock(), _createBlock("span", _hoisted_5, " (" + _toDisplayString(_ctx.$t("bookingV4.optional")) + ") ", 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", {
        id: "booking-v4-reference-container",
        "data-testid": "booking-v4-reference-container",
        class: ["flex flex-wrap items-center gap-2 w-full rounded-lg border p-2 bg-white", 
          _ctx.hasVisibleError
            ? 'border-red-lp-1200'
            : 'border-gray-lp-1500'
        ]
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderedChips, (chip, index) => {
          return (_openBlock(), _createBlock(_component_Chips, {
            key: chip.value,
            padding: "px-2.5",
            color: "bg-gray-lp-1000",
            textColor: "bg-black-lp-300",
            "data-testid": `booking-v4-reference-chip-${index}`
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_6, [
                _createVNode("span", _hoisted_7, _toDisplayString(chip.value), 1),
                _createVNode("button", {
                  type: "button",
                  "data-testid": `booking-v4-reference-chip-delete-${index}`,
                  class: "text-16px text-gray-lp-800 font-semibold leading-none",
                  onClick: ($event: any) => (_ctx.removeChip(index))
                }, " × ", 8, ["data-testid", "onClick"])
              ])
            ]),
            _: 2
          }, 1032, ["data-testid"]))
        }), 128)),
        _withDirectives(_createVNode("input", {
          id: "booking-v4-input-reference-external",
          "data-testid": "booking-v4-input-reference-external",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputValue = $event)),
          disabled: _ctx.isAtLimit || (_ctx.disabledManualStt && _ctx.disabledRefExternal),
          placeholder: 
            _ctx.modelValue.length === 0
              ? _ctx.$t('bookingV4.referenceNumber.placeholder')
              : ''
          ,
          class: "flex-1 min-w-[140px] outline-none text-sm text-black-lp-300 disabled:cursor-not-allowed",
          onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args))),
          onPaste: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args))),
          onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onInputBlur && _ctx.onInputBlur(...args)))
        }, null, 40, ["disabled", "placeholder"]), [
          [_vModelText, _ctx.inputValue]
        ])
      ], 2),
      (_ctx.referenceNumberError)
        ? (_openBlock(), _createBlock("p", _hoisted_8, _toDisplayString(_ctx.referenceNumberError), 1))
        : _createCommentVNode("", true),
      (_ctx.limitErrorMessage && _ctx.modelValue.length > 0)
        ? (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(_ctx.limitErrorMessage), 1))
        : _createCommentVNode("", true),
      (_ctx.duplicateTypeError && _ctx.modelValue.length > 0)
        ? (_openBlock(), _createBlock("p", _hoisted_10, _toDisplayString(_ctx.duplicateTypeError), 1))
        : _createCommentVNode("", true),
      (_ctx.isRefCanBeUsed)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _hoisted_12,
            _createVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("bookingV4.referenceNumber.eksternalRefCanBeUsed")), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("bookingV4.referenceNumber.helperText")), 1)
    ])
  ]))
}